/**
 * Sel-2 systems callouts — draws connector lines from product hotspots
 * down to feature cards. Mobile track scroll updates progress bar.
 */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 900px)');

  function parsePct(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : Math.max(0, Math.min(100, n));
  }

  function parseNum(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }

  function draw(root) {
    var container = root.querySelector('[data-sel-2-systems-connectors]');
    var media = root.querySelector('[data-sel-2-systems-media]');
    var items = root.querySelectorAll('[data-sel-2-systems-card]');
    if (!container || !media) return;

    container.innerHTML = '';

    if (!MQ.matches || !root.classList.contains('sel-2-systems-callouts--connectors')) return;

    var stage = root.querySelector('[data-sel-2-systems-stage]') || container.parentElement;
    var stageRect = stage.getBoundingClientRect();
    var mediaEl =
      media.querySelector('.sel-2-systems-callouts__img--desktop') ||
      media.querySelector('.sel-2-systems-callouts__placeholder') ||
      media.querySelector('img') ||
      media;
    var mediaRect = mediaEl.getBoundingClientRect();
    var stroke = root.getAttribute('data-connector-color') || '#007BFF';
    var strokeWidth = parseNum(root.getAttribute('data-connector-stroke'), 1);
    if (strokeWidth <= 0) strokeWidth = 1;
    var dotRadius = parseNum(root.getAttribute('data-connector-dot'), 4);

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'sel-2-systems-callouts__connectors-svg');
    svg.setAttribute('width', String(Math.max(1, stageRect.width)));
    svg.setAttribute('height', String(Math.max(1, stageRect.height)));
    svg.setAttribute('viewBox', '0 0 ' + Math.max(1, stageRect.width) + ' ' + Math.max(1, stageRect.height));
    svg.setAttribute('aria-hidden', 'true');

    Array.prototype.forEach.call(items, function (item) {
      var cardRect = item.getBoundingClientRect();
      var endPct = parsePct(item.getAttribute('data-end-x'), 50);
      var endX = cardRect.left - stageRect.left + (cardRect.width * endPct) / 100;
      var endY = cardRect.top - stageRect.top + 4;

      var tx = parsePct(item.getAttribute('data-target-x'), 50);
      var ty = parsePct(item.getAttribute('data-target-y'), 35);
      var startX = mediaRect.left - stageRect.left + (mediaRect.width * tx) / 100;
      var startY = mediaRect.top - stageRect.top + (mediaRect.height * ty) / 100;
      var showPoint = item.getAttribute('data-show-point') !== 'false';

      var elbowY = endY - 12;
      if (elbowY <= startY + 8) {
        elbowY = startY + Math.max(24, (endY - startY) * 0.55);
      }

      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute(
        'd',
        'M ' +
          startX.toFixed(1) +
          ' ' +
          startY.toFixed(1) +
          ' L ' +
          startX.toFixed(1) +
          ' ' +
          elbowY.toFixed(1) +
          ' L ' +
          endX.toFixed(1) +
          ' ' +
          elbowY.toFixed(1) +
          ' L ' +
          endX.toFixed(1) +
          ' ' +
          endY.toFixed(1)
      );
      path.setAttribute('class', 'sel-2-systems-callouts__line');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', stroke);
      path.setAttribute('stroke-width', String(strokeWidth));
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(path);

      if (showPoint && dotRadius > 0) {
        [
          { x: startX, y: startY },
          { x: endX, y: endY }
        ].forEach(function (pt) {
          var dot = document.createElementNS(svgNS, 'circle');
          dot.setAttribute('class', 'sel-2-systems-callouts__line-dot');
          dot.setAttribute('cx', pt.x.toFixed(1));
          dot.setAttribute('cy', pt.y.toFixed(1));
          dot.setAttribute('r', String(dotRadius));
          dot.setAttribute('fill', stroke);
          svg.appendChild(dot);
        });
      }
    });

    container.appendChild(svg);
  }

  function updateProgress(root) {
    var track = root.querySelector('[data-sel-2-systems-track]');
    var fill = root.querySelector('[data-sel-2-systems-progress-fill]');
    if (!track || !fill) return;

    var max = track.scrollWidth - track.clientWidth;
    if (max <= 0) {
      fill.style.width = '100%';
      return;
    }
    fill.style.width = Math.round((track.scrollLeft / max) * 100) + '%';
  }

  function bind(root) {
    var raf = 0;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        draw(root);
        updateProgress(root);
      });
    }

    schedule();
    window.addEventListener('resize', schedule);

    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', schedule);
    });

    var track = root.querySelector('[data-sel-2-systems-track]');
    if (track) {
      track.addEventListener('scroll', function () {
        updateProgress(root);
      }, { passive: true });
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(schedule);
      ro.observe(root);
      var media = root.querySelector('[data-sel-2-systems-media]');
      if (media) ro.observe(media);
      if (track) ro.observe(track);
    }

    if (MQ.addEventListener) MQ.addEventListener('change', schedule);
    else if (MQ.addListener) MQ.addListener(schedule);
  }

  function init() {
    var roots = document.querySelectorAll('[data-sel-2-systems-callouts]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.getAttribute('data-sel-2-systems-ready')) return;
      root.setAttribute('data-sel-2-systems-ready', 'true');
      bind(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
